import { FlexColumn, FlexRow } from '@editor/components/utilities/layouts';
import { h5 } from '@repo/ui/components/Typography';
import { VerticallyScrollable } from '@repo/ui/deprecated/VerticallyScrollable';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled(FlexColumn)`
  flex: 1;
  height: 100%;
  background: ${themeStyle.varBackgroundAltSolid};
  color: ${themeStyle.varInkMain};
`;

export const HeaderWrapper = styled(FlexRow)<{ $height: number }>`
  z-index: ${themeStyle.zIndexS3};
  position: relative;
  width: 100%;
  height: ${(props) => props.$height}px;
  align-items: center;
  transition: background 0.3s;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);

  &::before {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    background: ${themeStyle.varBackgroundAltSolid};
  }

  html[data-theme='dark'] &&,
  .dark && {
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.32);

    &::before {
      backdrop-filter: blur(4px);
    }
  }
`;

export const HeaderGrid = styled(FlexRow)`
  width: 100%;
  position: relative;
  align-items: center;
  justify-content: space-between;

  padding: 0 12px;
  ${QUERIES.tabletAndUp} {
    padding: 0 48px;
  }

  gap: 12px;
`;

export const LinkButton = styled.a`
  ${h5}

  color: ${themeStyle.varInkMedium};
  cursor: pointer;
`;

export const ContentWrapper = styled(VerticallyScrollable)`
  flex: 1;
`;

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 32px 0;

  ${QUERIES.tabletAndUp} {
    padding: 56px 0;
    max-width: 470px;
  }
`;
